import React from "react";
import styles from "./FullProfile.module.css";

export default function EducationSummary({ data }) {
  return (
    <>
      <h4>Education Summary</h4>
      <p>
        {data &&
          data.educationSummary &&
          data.educationSummary.split("\n").map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              <br />
            </React.Fragment>
          ))}
      </p>
      <div className={styles.grid}>
        {data?.educationalQualification.map((item) => (
          <div className={styles.companyProfile} key={item.institutionName}>
            <div className={styles.companyName}> {item.degree}</div>
            <div className={styles.instituteName}> {item.institutionName}</div>
            <div className={styles.duration}> {item.duration}</div>
            <div className={styles.department}> {item.department}</div>
          </div>
        ))}
      </div>
    </>
  );
}
